export enum GoogleActionsEnum {
  USER_CLICKED_BTN = 'Button clicked',
}
